import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Card from 'react-bootstrap/Card';
import User from './User';
import Back from './BackButton';
import '../style/dankmemes.css';

const server = process.env.REACT_APP_SERVER;

const MemeCards = ({memes, getUserImages}) => {
  return (
    memes && memes.length ?
      memes.map((imageObj, idx) => {
        return (
        <Card key={imageObj._id} index={idx} className="mx-auto mb-5 mt-2 float-left" bg="dark" text="light" id="meme-card">
          <Card.Img variant="top" alt={imageObj.uploaderId} src={imageObj.imageUrl} />
          <User getUser={getUserImages} username={imageObj.username} userId={imageObj.uploaderId}>{imageObj.username}</User>
        </Card>
        )
      })
    : null
  )
};

const DankMemes = ({ userId, username, token }) => {
  const [allMemes, setAllMemes] = useState([]);
  const [currentUser, setCurrentUser] = useState('');

  useEffect(() => {
    getAllMemes()
  },[])

  const getUserImages = async (id, username) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      const response = await axios.get(`${server}/meme/${id}`, config);
      const images = response.data.reverse();
      setAllMemes(images);
      setCurrentUser(username);
    } catch (err) {
      console.error(err.message)
    }
  }

  const getAllMemes = async () => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      const response = await axios.get(`${server}/meme`, config);
      const images = response.data.reverse();
      setAllMemes(images);
      setCurrentUser('');
    } catch (err) {
      console.error(err.message)
    }
  }

  if (allMemes.length) {
    return (
      <>
        {currentUser.length &&
          <>
            <div id="meme-card-2">
              <Back allMemes={getAllMemes}/>
            </div>
            <br></br>
            <div id='user-back-container'>
              <h1 className="dankMemes" id='user-handle'>@{currentUser}</h1>
            </div>
          </>
        }
          <MemeCards memes={allMemes} getUserImages={getUserImages}/>
          <div id="closing-statement">&nbsp;</div>
      </>
    )
  } else {
    return (
      <div id="user-back-container">
        <h3 className="nothing" style={{color: "white"}}>Nothing to see here...</h3>
      </div>
    )
  }
};

export default DankMemes;
